import Component from '../../shared/component';

export default class InviteModal extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$linkInput = this.$element.find('.inviteModal-link');
    this.$form = this.$element.find('.inviteModal-form');
    this.$emailsInput = this.$element.find('.inviteModal-form-emails');
    this.$messageInput = this.$element.find('.inviteModal-form-message');
    this.$successAlert = this.$element.find('.inviteModal-form-flash--notice');
    this.$errorAlert = this.$element.find('.inviteModal-form-flash--alert');

    this.bindEvents();
  }

  bindEvents() {
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.$linkInput.on('click.inviteModal', this.handleLinkClick);
    this.$form.on('ajax:send.inviteModal', this.handleSend);
    this.$form.on('ajax:success.inviteModal', this.handleSuccess);
    this.$form.on('ajax:error.inviteModal', this.handleError);
    this.$element.on('show.bs.modal.inviteModal', this.handleShow);

    // NOTE: If the Facebook SDK has loaded fast, we can immediately bind
    //       the event. Otherwise, we wait for the FacebookSDKLoaded event.
    this.handleFacebookSDKLoad = this.handleFacebookSDKLoad.bind(this);

    if (window.FB) this.bindFacebookEvents();
    window.$document.on('FacebookSDKLoaded', this.handleFacebookSDKLoad);
  }

  unbindEvents() {
    this.$linkInput.off('click.inviteModal', this.handleLinkClick);
    this.$form.off('ajax:send.inviteModal', this.handleSend);
    this.$form.off('ajax:success.inviteModal', this.handleSuccess);
    this.$form.off('ajax:error.inviteModal', this.handleError);
    this.$element.off('show.bs.modal.inviteModal', this.handleShow);

    try {
      window.FB.Event.unsubscribe('message.send', this.handleMessageSend);
    } catch (_error) {
      // Under iOS 11.x in Safari, an error occurred with Array.prototype being undefined
      // The error causes the impossibility for the user to collapse the sidebar
    }
  }

  bindFacebookEvents() {
    this.handleMessageSend = this.handleMessageSend.bind(this);

    try {
      window.FB.Event.subscribe('message.send', this.handleMessageSend);
    } catch (_error) {
      // Under iOS 11.x in Safari, an error occurred with Array.prototype being undefined
      // The error causes the impossibility for the user to collapse the sidebar
    }
  }

  handleFacebookSDKLoad() {
    this.bindFacebookEvents();
  }

  handleMessageSend() {
    this.resetAlerts();
    this.$successAlert.removeClass('hidden');
  }

  handleLinkClick() {
    // NOTE: this is a hack to be able to select & copy the content of
    // the input when it’s readonly
    this.$linkInput.attr('readonly', false);
    this.$linkInput.select();
    this.$linkInput.attr('readonly', true);
  }

  handleSuccess() {
    this.$successAlert.removeClass('hidden');
    this.resetForm();
  }

  handleError() {
    this.$errorAlert.removeClass('hidden');
  }

  resetForm() {
    this.$emailsInput.val('');
    this.$messageInput.val('');
  }

  resetAlerts() {
    this.$successAlert.addClass('hidden');
    this.$errorAlert.addClass('hidden');
  }

  handleShow() {
    this.resetForm();
    this.resetAlerts();
  }

  handleSend() {
    this.resetAlerts();
  }
}
